module.exports = __webpack_public_path__ + "static/img/order_banner.c2abdc1b.png";